module.exports = __webpack_public_path__ + "static/media/starwood-5.810cb254.jpg";